// Needs to match backend
export enum AssetDomains {
  ArkLife = 'ark.life',
  KicallArkLife = 'kicall.ark.life',
  KiCallStaging = 'staging.kicall.co.uk'
}